import { render, staticRenderFns } from "./ModifyTabla.vue?vue&type=template&id=b3648540&"
import script from "./ModifyTabla.vue?vue&type=script&lang=js&"
export * from "./ModifyTabla.vue?vue&type=script&lang=js&"
import style0 from "./ModifyTabla.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports